export default "<app-navigation></app-navigation>\n\n<div class=\"app-container\">\n  <router-outlet></router-outlet>\n</div>\n\n"